/* eslint-disable max-len */
import { React, useState, useCallback } from 'react'
import calculatePercentage from '../../../../../../../CommonMethods/percentageCalculator';
import { GetBranchId } from "../../../../../../../CommonMethods/GetBranchId";
import MonthTable from "./MonthTable";
import { dataService } from "../../../../../../../services/data.services";

const YearTable = ({ data: { records, reportsTotalCount }, selectedAY, selectedSection, searchParams }) => {

    
    const [expandedMonth, setExpandedMonth] = useState(null);
    const [expandedMonthData, setExpandedMonthData] = useState([]);
    const [expandedMonthLoading, setExpandedMonthLoading] = useState(false)
    const [expandedMonthDataCount, setExpandedMonthDataCount] = useState();

    const getExpandedReport = useCallback(async (selectedAY, selectedSection, monthName, index) => {
        try {
            if(expandedMonth === index)
            { 
                setExpandedMonth(null); 
                setExpandedMonthData([]);
                setExpandedMonthDataCount(0);
                return;
            }

            setExpandedMonth(index);
            const year = monthName.year;
            monthName = new Date(monthName.year, monthName.month - 1).toLocaleString("default", {month: "long"})
            
            const branch_id = await GetBranchId()
            
            setExpandedMonthLoading(true)
            let endpoint = `student-attendance?branch_id=${branch_id}&student_id=${searchParams?.get('std_id')}&academic_year_id=${selectedAY?.academic_year?.academic_year_id}&class_id=${selectedAY?.class_id}&section_id=${selectedSection?.section_id}&filter=true&page_number=1`;
            endpoint += "&page_number=1&type=month&month=" + monthName + "&year=" + year;

            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data?.data;
            setExpandedMonthData(temp)
            setExpandedMonthLoading(false)
            setExpandedMonthDataCount(temp?.length)

        } catch (error) {
            setExpandedMonthDataCount(0)
            setExpandedMonthData([])
            if (error?.response?.data?.message == 'No records found') { return; }
            console.log(error?.response?.data?.message || "Something went wrong")
            console.log(error)
        } finally {
            setExpandedMonthLoading(false)
        }
    }, [expandedMonth,selectedAY, selectedSection, expandedMonthDataCount]);



    return (
        <div class=" w-full px-20 relative">
            <div class=" overflow-x-auto pb-2.5 scroll-bar -mx-[2px]">
                <div class="flex px-[6px] mb-8" id="search-result">
                    <table aria-label="Outside Table" class="w-full" id="admin-table">
                        <thead>
                            <tr>
                                <th class="w-[25%]">
                                    <span >Month
                                    </span>
                                </th>
                                <th class="w-[25%]">
                                    <span class="flex items-center justify-end">Total Days
                                    </span>
                                </th>
                                <th class="w-[25%]">
                                    <span class="flex items-center justify-end">Present
                                    </span>
                                </th>
                                <th class="w-[25%]">
                                    <span class="flex items-center justify-end">Absent
                                    </span>
                                </th>
                                <th class="w-[25%]">
                                    <span class="flex items-center justify-end">Percentage
                                    </span>
                                </th>
                            </tr>
                            <tr aria-colspan="7" class="h-1"></tr>
                        </thead>
                        <tbody >
                            {
                                records.map((month, index) => (<>
                                    <tr key={index} onClick={() => getExpandedReport(selectedAY, selectedSection, month, index)} className="text-center cursor-pointer" title="View Monthly Attendance">
                                        <td className="text-start flex">
                                            <span class="flex mr-1 mt-[2px]">
                                                <img loading="lazy" decoding="async" src={expandedMonth === index ? "/images/down-arrow.svg" : "/images/right-arrow.svg"} alt="img" id="modify_attendance" class="w-5 h-5  prevent-click hover:bg-[#eef7fe]"/>
                                            </span>
                                            <span class="flex">{new Date(month.year, month.month - 1).toLocaleString("default", {
                                                month: "short",
                                                year: "numeric",
                                            })}</span>
                                        </td>
                                        {Number(month.total_days) > 0 ? <>
                                            <td className="text-end">{month.total_days}</td>
                                            <td className="text-end">{month?.present_days}</td>
                                            <td className="text-end">{month?.absent_days}</td>
                                            <td className="text-end">{calculatePercentage(month.present_days, month.total_days)}%</td>
                                        </> : <>
                                            <td className="text-end">-</td>
                                            <td className="text-end">-</td>
                                            <td className="text-end">-</td>
                                            <td className="text-end">-</td>
                                        </>}
                                    </tr>
                                    {expandedMonth === index && (
                                        <tr>
                                            <td colSpan={5} className="p-2">
                                                <div className="max-h-[240px] overflow-auto scroll-bar px-2 ">
                                                    <MonthTable data={{ records: expandedMonthData, reportsTotalCount: expandedMonthDataCount }} isLoading={expandedMonthLoading} isNestedTable={true}/>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </>
                                ))
                            }

                        </tbody>
                        {reportsTotalCount === 0 && (
                            <tbody>
                                <tr>
                                    <td style={{ 'line-height': '100px' }} colspan={5} className="no-records-message">
                                        {'No matching records found.'}
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </div>
    )
}
export default YearTable;   